import { atom } from 'jotai';

import {
  BogoInfo,
  CustomAdditionalOptionList,
  CustomOptionsInfo,
  CustomProductOptionList,
  CustomTextOption,
  ProductItem,
  RestockNotificationInfo,
  RestockNotificationStatus,
  SelectedItemMap,
  SelectedOption,
} from '../types/option-type';

export const ProductIdAtom = atom<string>('');
// MEMO: 최초 응답 옵션 데이터 저장
export const OptionSourceDataAtom = atom<CustomOptionsInfo | null>(null);
export const OriginOptionDataAtom = atom<CustomOptionsInfo | null>(null);
export const OptionsAtom = atom<SelectedOption[][]>([]);
export const TextOptionsAtom = atom<CustomTextOption[][]>([]);
export const AdditionalOptionsAtom = atom<CustomAdditionalOptionList[] | null>(null);
export const SelectedOptionRestockNotiInfoAtom = atom<RestockNotificationInfo>({} as RestockNotificationInfo);
export const MachingOptionAtom = atom<CustomProductOptionList[] | null>(null);

export const ItemsAtom = atom<SelectedItemMap>({} as SelectedItemMap);
export const MaximumCountAtom = atom<number>(999);
export const ActiveIndexAtom = atom<number>(0);
export const ActiveParentIndexAtom = atom<number>(0);
export const FirstSoldoutIndexAtom = atom<number>(-1);
export const ProductItemListAtom = atom<ProductItem[]>([]);
export const BogoInfoAtom = atom<BogoInfo | null>(null);
export const BogoRequiredQuantityAtom = atom<number | null>(null);

export const IsSingleSelectionAllowedAtom = atom<boolean>(false);
export const IsProductTypeZigzinAtom = atom<boolean>(false);
export const IsRestockNotiDrawerShownAtom = atom<boolean>(false);
export const IsItemsShownAtom = atom<boolean>(false);
export const IsShowShippingDetailAtom = atom<boolean>(false);

export const displayDeliveryTypeToggleButtonAtom = atom<boolean>(false);

export const OnlyZigzinOptionAtom = atom<boolean>(false);
export const RestockNotiStatusAtom = atom<RestockNotificationStatus>(null);
